import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Get in touch`}</h2>
    <p>{`Say Hi or find me on other platforms:`}<a parentName="p" {...{
        "href": "https://www.linkedin.com/in/shahreear-wadud-766a18143/"
      }}>{`LinkedIn`}</a>{`, `}<a parentName="p" {...{
        "href": "https://www.facebook.com/chittychittybangbang07/"
      }}>{`facebook`}</a>{`,
`}<a parentName="p" {...{
        "href": "https://www.instagram.com/batrachotxin/"
      }}>{`instagram`}</a>{`, `}<a parentName="p" {...{
        "href": "https://github.com/Potato-dragon/mesarthiumfortress"
      }}>{`github`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      